// extracted by mini-css-extract-plugin
export var container = "VideoMask-module--container--5SZAv";
export var rect = "VideoMask-module--rect--5Wo0p";